import { render, staticRenderFns } from "./RoleTemplateTable.vue?vue&type=template&id=7318a3d0"
import script from "./RoleTemplateTable.vue?vue&type=script&lang=js"
export * from "./RoleTemplateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports